import React from 'react';
import { Link } from 'react-router-dom';

class BackButton extends React.Component {

  render() {
    const theme = this.props.theme;
    return (
      theme ?
        <Link to="/">
          <div className="bg-white flex justify-center items-center mt-6 shadow-lg w-20 py-2 rounded-md cursor-pointer 
        transform transition-transform duration-300 hover:scale-105 sm:w-32 md:w-40 lg:w-32 sm:py-2 md:px-6">
            <img src="../assets/arrow-left.svg" alt="back button icon" className="w-4 h-auto mr-2 sm:w-6 md:w-8 lg:w-6" />
            <h6 className="theme-select text-sm font-medium sm:text-lg md:text-xl lg:text-base">Back</h6>
          </div>
        </Link> :
        <Link to="/">
          <div className="bg-gray-800 flex justify-center items-center mt-6 shadow-lg w-20 py-2 rounded-md cursor-pointer 
        transform transition-transform duration-300 hover:scale-105 sm:w-32 md:w-40 lg:w-32 sm:py-2 md:px-6">
            <img src="../assets/arrow-left-white.svg" alt="back button icon" className="w-4 h-auto mr-2 sm:w-6 md:w-8 lg:w-6" />
            <h6 className="theme-select text-sm text-gray-400 font-medium sm:text-lg md:text-xl lg:text-base">Back</h6>
          </div>
        </Link>
    );
  }
}

export default BackButton;
